import { memo, useState } from "react";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";

import useAnalytics from "effect/use_analytics";

import RuleTable from "./Table";

const RuleManagementPage = memo(function RuleManagementPage(): JSX.Element {
  useAnalytics("Findings: Rule Management");

  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <Box sx={{ backgroundColor: "#FFF", p: 3 }}>
        <Typography variant="h4" fontWeight="bold">
          Rule Management
        </Typography>

        <TextField
          variant="outlined"
          size="small"
          type="text"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          sx={{ mt: 2, alignSelf: "flex-start" }}
          placeholder="Search"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
            endAdornment: searchTerm ? (
              <InputAdornment position="end">
                <CancelIcon
                  style={{ cursor: "pointer" }}
                  onClick={() => setSearchTerm("")}
                />
              </InputAdornment>
            ) : null,
          }}
        />
      </Box>
      <Divider />

      <Box sx={{ mx: 3, mt: 3, mb: 6, display: "flex", flexGrow: 1 }}>
        <RuleTable searchTerm={searchTerm} />
      </Box>
    </>
  );
});

export default RuleManagementPage;
